<svg width="214" height="90" viewBox="0 0 214 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8996_234640)">
<path d="M23.7148 -7L23.7148 93" stroke="#E4E4E4"/>
<path d="M50.4297 -7L50.4297 93" stroke="#E4E4E4"/>
<path d="M77.1445 -7L77.1445 93" stroke="#E4E4E4"/>
<path d="M103.855 -7L103.855 93" stroke="#E4E4E4"/>
<path d="M130.57 -7L130.57 93" stroke="#E4E4E4"/>
<path d="M157.285 -7L157.285 93" stroke="#E4E4E4"/>
<path d="M184 -7L184 93" stroke="#E4E4E4"/>
<path d="M0.5 78.5625L214.5 78.5625" stroke="#E4E4E4"/>
<path d="M0.5 55.1875L214.5 55.1875" stroke="#E4E4E4"/>
<path d="M0.5 31.8125L214.5 31.8125" stroke="#E4E4E4"/>
<path d="M0.5 8.4375L214.5 8.43749" stroke="#E4E4E4"/>
<rect x="51.5" y="8" width="53" height="82" rx="7" fill="#EEBED4"/>
<rect x="108.5" y="32" width="55" height="58" rx="7" fill="#61BC76"/>
</g>
<defs>
<clipPath id="clip0_8996_234640">
<rect width="214" height="90" fill="white"/>
</clipPath>
</defs>
</svg>
